import React, { useEffect, useRef } from 'react';
import foto1 from '../../../media/img/products/proyectos_nuestros.jpg';
import foto2 from '../../../media/img/products/proyectos_elegirnos.jpg';
import './productsInfoCompany.scss';

const ProductoInfoCompany = () => {
  const imageRefs = useRef([]);
  const lineRefs = useRef([]);
  const parRefs = useRef([]);

  useEffect(() => {
    const observerOptions = {
      threshold: 0.2,
      rootMargin: '0px 0px 0px 0px',
    };

    const imageObservers = imageRefs.current.map((imgRef) => {
      if (!imgRef) return null;
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const direction = entry.target.dataset.direction;
            entry.target.classList.add(
              `product-info__image--${direction}-visible`,
            );
            observer.unobserve(entry.target);
          }
        });
      }, observerOptions);
      observer.observe(imgRef);
      return observer;
    });

    const lineObservers = lineRefs.current.map((lineRef) => {
      if (!lineRef) return null;
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('content__title-line--visible');
            observer.unobserve(entry.target);
          }
        });
      }, observerOptions);
      observer.observe(lineRef);
      return observer;
    });

    const parObservers = parRefs.current.map((parRef) => {
      if (!parRef) return null;
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('product-info__text--visible');
            observer.unobserve(entry.target);
          }
        });
      }, observerOptions);
      observer.observe(parRef);
      return observer;
    });

    return () => {
      imageObservers.forEach((obs) => obs?.disconnect());
      lineObservers.forEach((obs) => obs?.disconnect());
      parObservers.forEach((obs) => obs?.disconnect());
    };
  }, []);

  return (
    <div className="product-info">
      <section className="product-info__section">
        <div className="product-info__image-container">
          <img
            ref={(el) => (imageRefs.current[0] = el)}
            data-direction="right"
            className="product-info__image product-info__image--right"
            src={foto1}
            alt="Nuestros Proyectos"
          />
        </div>
        <div className="product-info__content">
          <h1 className="product-info__title content__title-backgroundWhite">
            Nuestros Proyectos
          </h1>
          <div
            ref={(el) => (lineRefs.current[0] = el)}
            className="content__title-line"
          />
          <div
            ref={(el) => (parRefs.current[0] = el)}
            className="product-info__text product-info__text--hidden"
          >
            <p className="content__text-title-backgroundWhite">
              En Wonderaly Innovations desarrollamos proyectos pioneros que
              integran neuropsicología, inteligencia artificial e impacto
              social. Cada proyecto nace de una necesidad real y se desarrolla
              con rigor científico y compromiso con las personas.
            </p>
            <p className="content__text-title-backgroundWhite">
              Desde la optimización de producciones cinematográficas hasta la
              prevención del suicidio en jóvenes, nuestros proyectos demuestran
              que la ciencia del comportamiento humano puede transformar
              industrias y salvar vidas.
            </p>
          </div>
        </div>
      </section>

      <hr className="divider dividermedia" />

      <section className="product-info__section product-info__section--reverse">
        <div className="product-info__content">
          <h1 className="product-info__title content__title-backgroundWhite">
            ¿Por qué elegirnos?
          </h1>
          <div
            ref={(el) => (lineRefs.current[1] = el)}
            className="content__title-line"
          />
          <div
            ref={(el) => (parRefs.current[1] = el)}
            className="product-info__text product-info__text--hidden"
          >
            <p className="content__text-title-backgroundWhite">
              Somos pioneros en la integración de la neuropsicología en la
              producción audiovisual. Nuestro enfoque combina rigor científico,
              tecnología avanzada y un profundo conocimiento del comportamiento
              humano para generar resultados medibles y reales.
            </p>
            <p className="content__text-title-backgroundWhite">
              Nos implicamos en cada proyecto de forma personalizada,
              acompañando a los equipos creativos e instituciones desde el
              inicio hasta el final. Elegirnos es contar con un socio científico
              comprometido con la excelencia y el impacto social.
            </p>
          </div>
        </div>
        <div className="product-info__image-container">
          <img
            ref={(el) => (imageRefs.current[1] = el)}
            data-direction="left"
            className="product-info__image product-info__image--left"
            src={foto2}
            alt="¿Por qué elegirnos?"
          />
        </div>
      </section>
    </div>
  );
};

export default ProductoInfoCompany;
